<template>
    <div class="u-padding-narrow u-full-height">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <div class="product | u-wizard-padding-bottom">
                    <div class="product__title">
                        <h2 class="beta | u-margin-bottom-narrow">{{ trans('order.choose-hosting') }}</h2>
                    </div>
                    <hosting-partial :domain="{ domain: domain }" :index="0" />
                </div>
            </div>
        </div>

        <div class="wizard-footer">
            <span class="u-margin-bottom-responsive">
                <small v-html="trans('order.support')"></small>
            </span>
            <div>
                <customer-router-link :to="{ name: 'orderHostingOverview', params: { domain: domain } }">
                    <div class="button-nav-submit">
                        <button type="button" dusk="step3-submit-button" class="btn btn--ghost btn--submit btn--nav">
                            {{ trans('order.overview') }}
                        </button>
                    </div>
                </customer-router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { HostingPartial, singleServiceMixin, orderPageMixin } from 'relapp-register';

export default {
    components: {
        HostingPartial
    },
    mixins: [singleServiceMixin, orderPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: 'hosting'
        };
    },
    computed: {
        ...mapGetters({
            getHosting: 'order/hosting'
        })
    },
    metaInfo: {
        title: trans('page.order.hosting')
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        // Remove all order items except previously selected hosting product for our domain.
        const hostingProduct = this.getHosting({ domain: this.domain });

        this.resetOrder();
        this.setCustomer(this.getCustomer);

        if (hostingProduct) {
            this.switchHosting(hostingProduct);
        }
    },
    methods: {
        ...mapActions({
            switchHosting: 'order/switchHosting'
        })
    }
};
</script>
